module.exports = "<div class=\"spinner-container\" *ngIf=\"loadingStatus\">\r\n    <div class=\"spiner-wrp\"></div>\r\n    <img src=\"../../assets/icons/loadingSpinner.gif\" alt=\"loadingSpinner\">\r\n</div>\r\n<!--*ngIf=\"loadingStatus\"-->"


//////////////////
// WEBPACK FOOTER
// ./src/app/loading-spinner/loading-spinner.component.html
// module id = ./src/app/loading-spinner/loading-spinner.component.html
// module chunks = main